import { render, staticRenderFns } from "./WorkOrders.vue?vue&type=template&id=2bc435a3&"
import script from "./WorkOrders.vue?vue&type=script&lang=js&"
export * from "./WorkOrders.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrders.vue?vue&type=style&index=0&id=2bc435a3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports